import { StatusBar } from "expo-status-bar";
import React from "react";
import { Image, StyleSheet, Text, View } from "react-native";

import Privacy from "./src/screens/Privacy";

export default function App() {
  const NavBarMobile = () => {
    return (
      <View
        style={{
          backgroundColor: "white",
          width: "100%",
          height: 100,
          flexDirection: "row",
          justifyContent: "centre",
          alignItems: "center",
        }}
      >
        <View
          style={{
            width: 100,
            height: "100%",
            paddingTop: 25,
            paddingLeft: 20,
          }}
        >
          <Image
            style={{ width: 135, height: 50 }}
            source={require("./assets/logoheader.png")}
          />
        </View>
      </View>
    );
  };
  const HeaderMobile = () => {
    return (
      <View
        style={{
          backgroundColor: "white",
          width: "100%",
          justifyContent: "centre",
          alignItems: "center",
        }}
      >
        <View
          style={{
            height: "100%",
          }}
        >
          <Image
            style={{ width: 1080 / 5, height: 1080 / 5 }}
            source={require("./assets/icon.png")}
          />
        </View>
      </View>
    );
  };

  return (
    <View style={styles.container}>
      <NavBarMobile />
      <HeaderMobile />
      <View style={{ width: "80%", paddingTop: 20 }}>
        <Privacy />
      </View>

      <StatusBar style="auto" />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    backgroundColor: "#fff",
    alignItems: "center",
    justifyContent: "center",
  },
});
